import { jsx } from 'react/jsx-runtime';
import cn from 'classnames';
import S from './AssistiveText.styl.js';

function AssistiveText(props) {
    const { className, size = 'm', variant = 'default', children, ...rest } = props;
    return (jsx("div", { className: cn(S.root, S[`size-${size}`], S[`variant-${variant}`], className), ...rest, children: children }));
}

export { AssistiveText };
